{
  "add_peer": "Add peer",
  "add_focus": "Add focus",
  "add_specific_focus": "Add specific focus if needed...",
  "edit_focus": "Edit focus",
  "edit_peers": "Edit peers",
  "focus_from": "{name} asked:",
  "add_reviewer_type": "Add reviewer type",
  "add_review_type_workflow": "Add review type",
  "add_rule": "Add rule",
  "additional_feedback": "Additional feedback",
  "additional_feedback_choose_colleague": "Choose colleague",
  "colleague_name": "Colleague name",
  "additional_feedback_search_colleague": "Search colleague",
  "additional_feedback_choose_where": "Choose where to leave feedback",
  "additional_feedback_choose_review_error": "Please select which review to leave feedback in",
  "additional_feedback_description": "Only colleagues in active review cycles are available",
  "additional_feedback_pre_title": "Want to leave additional feedback?",
  "additional_feedback_title": "Choose any colleague participating in an active review cycle.",
  "ai_evaluating_description": "We are analyzing the feedback to provide you with insights. This may take a few minutes.",
  "ai_evaluating_title": "AI analysis in progress",
  "ai_feature_description": "Use AI to summarize responses and highlight key insights",
  "ai_feature_title": "Reviews AI",
  "ai_waiting_description": "Analysis will begin after enough feedback is collected.",
  "ai_waiting_title": "AI is ready for analysis",
  "all_questions": "All numeric questions",
  "no_answers_yet": "No answers yet",
  "all_set_and_ready_description": "Invitations will be sent, users will start to answer",
  "all_set_and_ready_schedule_description": "Invitations will be sent on schedule",
  "all_set_and_ready_schedule_title": "All is set and ready to go.\nLaunch later as planned?",
  "all_set_and_ready_title": "All is set and ready to go.\nCan we launch this review right now?",
  "answer_anonymously": "Answer anonymously",
  "app_notification_invite_peers_pre_title": "Pick your peers who will review you",
  "app_notification_invite_peers_pre_title_selected": "{title} is active",
  "app_notification_invite_peers_title_selected": "Feedback peers have already been selected. You can review or update the list anytime",
  "app_notification_invite_peers_title": "They'll be invited to review you during",
  "app_notification_invited_respond_group_title": "{count, plural, =0{} one{} other{# people are waiting for your review}}",
  "app_notification_invited_respond_title": "You've been invited to give a review {type, select, myself {of yourself} manager {of your direct report} peer {of a peer} upward {of your manager} other {of an employee}}",
  "auto_share_timing_after_end": "When the cycle ends",
  "auto_share_timing_immediately": "Immediately after completion",
  "average_score_based_on_responses": "Average {score} based on {count, plural, one{# response} other{# responses}}",
  "avg_by_all_reviewer_types": "Average by all reviewer types",
  "change_manager": "Change manager",
  "chart_performance_good": "Good Performance",
  "chart_performance_lower": "Lower Performance",
  "chart_title_good_custom": "{title}: satisfied",
  "chart_title_good_manager": "Manager satisfied",
  "chart_title_good_peer": "Peers satisfied",
  "chart_title_good_self": "Self confident",
  "chart_title_good_upward": "Team satisfied",
  "chart_title_lower_custom": "{title}: less satisfied",
  "chart_title_lower_manager": "Manager less satisfied",
  "chart_title_lower_peer": "Peers less satisfied",
  "chart_title_lower_self": "Self less confident",
  "chart_title_lower_upward": "Team less satisfied",
  "choose_form": "Choose form",
  "choose_forms": "Choose forms",
  "complete_review": "Complete review",
  "complete_review_confirm": "After completion, you will receive the final statistics and employees will no longer be able to participate in the review",
  "complete_review_question": "Do you want to complete the review?",
  "configure_chart": "Configure chart",
  "configure_form_description": "You can choose an existing template and edit its questions for this particular review, or create a new set of questions from scratch",
  "configure_forms": "Configure forms",
  "configure_participants": "Configure participants",
  "create_reviewer_type": "Create new type",
  "create_performance_review": "Create review",
  "create_review_template": "Create template",
  "do_not_use_emoji": "Don't use hero emoji for this review",
  "edit_review": "Edit review",
  "employee_performance_empty_state_description": "Once completed reviews are available, you will see them here",
  "employee_performance_empty_state_title": "No reviews yet",
  "empty_state_performance_review_templates_description": "Templates help you quickly set up consistent reviews by reusing common questions.\nStart here to save time and ensure every review follows your company's evaluation standards.",
  "empty_state_performance_review_templates_title": "Create your first review template",
  "feedback_evaluation": "Feedbacks",
  "feedbacks_to_leave": "Feedbacks to leave",
  "feedbacks_left": "Feedbacks left",
  "feedback_about_me": "Feedback about me",
  "feedback_ive_given": "Feedback I’ve given",
  "feedbacks_left_empty_title": "No feedbacks left yet",
  "feedbacks_left_empty_description": "Your completed feedbacks will appear here",
  "final_score_breakdown": "Final score breakdown",
  "go_to_review": "Go to review",
  "goal_question_period_caption": "Only goals whose end date falls within this period will be included in the review.",
  "goal_question_period_end": "Ends by",
  "goal_question_period_start": "Ends from",
  "goal_question_period_title": "Goal end date period",
  "goal_question_show_when_no_goals": "Show question even if there are no active goals",
  "goal_question_single_rating": "Rate all goals with a single mark",
  "group": "Group",
  "insights": "Insights",
  "invitation_description": "Write a custom email inviting participants to the review.",
  "invitation_settings": "Invitation settings",
  "configure_invitations_by_reviewer_type": "Customize invitations by reviewer group",
  "invitation_mode_by_reviewer_type": "Different invitation for each reviewer type",
  "invitation_mode_by_reviewer_type_description": "Configure an independent subject and message for every reviewer type",
  "invitation_mode_common": "One invitation for all reviewer types",
  "invitation_mode_common_description": "Use the same subject and message for every reviewer",
  "variable_participant_full_name": "Participant full name",
  "invite_co_owners_description": "They will be able to modify review like you, except of inviting other co-owners",
  "invite_co_owners_title": "Invite co-owners",
  "launch_on_schedule": "Launch on schedule",
  "launch_review": "Launch review",
  "launch_review_confirm": "Are you sure you want to launch the review?",
  "leave_feedback_about_your_work": "Leave feedback about your work",
  "leave_performance_feedback": "Leave performance feedback",
  "my_feedback": "My feedback",
  "my_reviews": "My reviews",
  "my_reviews_empty_description": "Employees for review will appear here",
  "my_reviews_empty_title": "No employees to review",
  "my_team_empty_description": "Your team's review results will appear here",
  "my_team_empty_title": "No results for your team",
  "my_direct_reports_empty_description": "Once reviews are available, we'll show them here",
  "my_direct_reports_empty_title": "There are no reviews about your direct reports yet",
  "open_review": "Open review",
  "overall": "Overall",
  "overall_ratings": "Overall ratings",
  "overall_score": "Overall score",
  "pause_review": "Pause review",
  "performance": "Performance",
  "performance_review": "Review",
  "performance_review_notification_description": "New reviews to complete or review results available",
  "performance_review_template": "Review template",
  "performance_review_templates": "Performance review templates",
  "performance_reviews": "Reviews",
  "performance_review_cycles": "Performance review cycles",
  "review_cycles": "Review cycles",
  "review_cycle": "Review cycle",
  "cycle_status": "Cycle status",
  "feedback_on_my_direct_reports": "Feedback on my direct reports",
  "feedback_on_my_subordinates": "Feedback on my subordinates",
  "reviews_completed_of": "{current} of {total} completed",
  "new_review_cycle": "New review cycle",
  "performance_reviews_empty_state_description": "Find out what really matters to your team.\n Ask the right questions, get honest answers, and use the results to make work better for everyone",
  "performance_reviews_empty_state_title": "Start your first review",
  "performance_reviews_empty_state_viewer_title": "No review cycles yet",
  "performance_reviews_empty_state_viewer_description": "Review cycles available to you will appear here.",
  "performance_reviews_feature_description": "Conduct regular reviews, collect feedback, and track employee performance",
  "performance_reviews_module": "Access review system",
  "performance_reviews_module_description": "Required for all review interactions",
  "permissions_performance_review_templates_edit_description": "Create, modify, and manage review templates for the organization",
  "permissions_performance_review_templates_none_description": "Cannot view or use any review templates",
  "permissions_performance_review_templates_title": "Review templates",
  "permissions_performance_review_templates_view_description": "See existing templates without making changes",
  "permissions_performance_reviews_create": "Create new reviews",
  "permissions_performance_reviews_create_description": "Allow to build reviews for employees",
  "permissions_performance_reviews_manage_all": "Manage existing reviews",
  "permissions_performance_reviews_manage_all_description": "Edit, schedule, or delete any reviews in the system",
  "personal_feedbacks": "Personal feedbacks",
  "no_goals_to_evaluate": "No goals to evaluate",
  "question_type_goal": "Goal evaluation",
  "question_type_goal_caption": "Evaluate goals that end in a selected period",
  "rating": "Rating",
  "ratings": "Ratings",
  "ratings_description": "Select the questions to be evaluated",
  "reopen_review": "Reopen review",
  "reopen_review_confirm": "The review will be reopened and employees will be able to continue participating.",
  "reopen_review_question": "Do you want to reopen the review?",
  "result_not_available_description": "This is an anonymous review. To protect privacy, results will be shown when enough responses are collected",
  "result_not_available_title": "Results not available yet",
  "resume_feedback": "Resume feedback",
  "review_closed_description": "This review is no longer accepting responses.",
  "responses_submitted_title": "Your responses have been submitted",
  "review_completed_description": "Thank you for participating!",
  "review_completed_title": "Review completed",
  "review_date_ends_at": "Review end date",
  "review_has_been_updated_description": "All changes have been saved successfully",
  "review_has_been_updated_title": "Your review has been updated",
  "review_type": "Review type",
  "review_type_custom": "Custom group",
  "review_type_manager": "Manager review",
  "review_type_manager_short": "Manager",
  "review_type_peer": "Peer",
  "review_type_peer_description": "Selection will be enabled after setup is completed",
  "review_type_peer_short": "Peers",
  "review_type_self": "Self review",
  "review_type_self_short": "Self",
  "review_type_upward": "Upward review",
  "review_type_upward_short": "Upward",
  "reviewee": "Reviewee",
  "reviewer_status_added": "Added",
  "reviewer_status_completed": "Completed",
  "reviewer_status_in_progress": "In progress",
  "reviewer_status_invited": "Invited",
  "reviewer_type": "Reviewer type",
  "reviewer_type_invitation": "Invitation content",
  "reviewer_type_invitation_description": "Leave both fields empty to use the standard system template",
  "reviewers": "Reviewers",
  "review_types": "Review types",
  "manage": "Manage",
  "reviewers_description": "Which types of reviewers do you want to include? ",
  "reviewers_settings": "Reviewers settings",
  "reviewers_settings_description": "Let's configure some access and visibility settings",
  "reviews": "Reviews",
  "same_ratings_reviewer_types": "Same ratings for all reviewer types",
  "score": "Score",
  "select_group": "Select group",
  "select_manager": "Select manager",
  "select_peers": "Select peers",
  "select_template_description": "Choose an existing template or create a new one to build your review",
  "select_template_title": "Select review template",
  "set_manager": "Assigned manager",
  "settings_anonymity": "Anonymity",
  "settings_anonymous_threshold": "Number of answers to unveil results",
  "settings_is_allow_manager_early_access": "Allow manager to access review before completing their own review",
  "settings_is_allow_manager_sharing": "Allow manager to share review with the reviewee",
  "settings_is_allow_edit_after_submit": "Allow editing answers after submission",
  "settings_is_allow_edit_after_submit_description": "Reviewers can change their answers until the results are shared with the reviewee. After sharing, editing reopens by removing the share.",
  "settings_is_allow_to_invite": "Allow reviewee to invite peers",
  "settings_is_allow_manager_to_invite": "Allow reviewee's manager to invite peers",
  "settings_is_allow_feedback_from_anyone": "Allow employees outside this group to join reviews",
  "settings_is_allow_feedback_from_anyone_description": "Employees can add themselves to this review group and leave feedback",
  "settings_is_auto_share": "Automatically share with the reviewee",
  "settings_is_notify_owners_on_complete": "Notify owners when the review is complete",
  "settings_make_anonymous": "Make anonymous",
  "setup_peers": "Setup peers",
  "setup_peers_in_custom": "Setup {name}",
  "share": "Share",
  "share_all_feedback_description": "{name} will see all the available feedback",
  "share_all_feedback_select_title": "Select which feedback {name} will see",
  "share_all_feedback_title": "Share all feedback",
  "share_feedbacks": "Share feedbacks",
  "shared": "Shared",
  "skip_and_leave_as_draft": "Skip and leave as draft",
  "start_from_scratch_description": "Create new set of questions",
  "start_from_scratch_title": "Start from scratch",
  "start_review": "Start review",
  "start_share_with": "Share with {name}",
  "stop_sharing_with": "Stop sharing feedback with {name}",
  "use_ai_description": "Generate automatic insights from review feedback",
  "use_ai_title": "Use AI to analyze responses",
  "unsolicited": "Unsolicited",
  "who_to_review": "Who to review?",
  "x_axis": "Horizontal axis",
  "y_axis": "Vertical axis",
  "you_been_invited_to_select_peers": "You’ve been invited to select peers for your review",
  "~": "~"
}
